module.exports = __webpack_public_path__ + "img/zhengshu2.fa0b4494.jpg";